import { Option } from './types';

export const genders = [
  { label: 'Female', value: 'female' },
  { label: 'Male', value: 'male' },
];

export const anuraScores = [
  { label: 'Non-suspect', value: 'NONSUSPECT' },
  { label: 'Suspect', value: 'SUSPECT' },
  { label: 'No Score', value: 'NOSCORE' },
];

export const browserTypes = [
  { label: 'Desktop', value: 'Desktop' },
  { label: 'Mobile', value: 'Mobile' },
];

export const userDataFields: Option[] = [
  'email',
  'first_name',
  'last_name',
  'gender',
  'dob',
  'phone',
  'zip',
  'state',
  'city',
  'address_1',
]
  .map((k) => ({ label: k.replace(/_/g, ' '), value: k }))
  // ip_zip is the zip from the user's IP lookup (not a user field); whatif-server reads it from the session
  .concat({ label: 'ip to zip', value: 'ip_zip' });

export const restrictionTypes = [
  { label: 'Available', value: 'Available' },
  { label: 'Unavailable', value: 'Unavailable' },
  { label: 'Partially Restricted', value: 'Partially Restricted' },
];

export const includeExcludeOptions = [
  { label: 'Include', value: 'Include' },
  { label: 'Exclude', value: 'Exclude' },
];

export const DAY_PARTING_DAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'] as const;

export const BULK_ACTION_DAY_MAPPING: Record<string, readonly string[]> = {
  all: DAY_PARTING_DAYS,
  weekdays: DAY_PARTING_DAYS.slice(0, 5),
  weekend: DAY_PARTING_DAYS.slice(5),
};

// Cap interval options for the main cap dropdown
// Values use capitalized format (Daily, Monthly, Lifetime) for backward compatibility with existing data
export const capIntervalOptions = [
  { label: 'None', value: '' },
  { label: 'Daily', value: 'Daily' },
  { label: 'Monthly', value: 'Monthly' },
  { label: 'Lifetime', value: 'Lifetime' },
];

// Day-of-week cap types for capConfiguration
export const DOW_CAP_TYPES = {
  DOW_MONDAY: { label: 'Monday', value: 'DOW_MONDAY' },
  DOW_TUESDAY: { label: 'Tuesday', value: 'DOW_TUESDAY' },
  DOW_WEDNESDAY: { label: 'Wednesday', value: 'DOW_WEDNESDAY' },
  DOW_THURSDAY: { label: 'Thursday', value: 'DOW_THURSDAY' },
  DOW_FRIDAY: { label: 'Friday', value: 'DOW_FRIDAY' },
  DOW_SATURDAY: { label: 'Saturday', value: 'DOW_SATURDAY' },
  DOW_SUNDAY: { label: 'Sunday', value: 'DOW_SUNDAY' },
} as const;

// Mapping from day name to DOW cap type - used for syncing dayHourRestrictions with capConfiguration
export const DAY_TO_DOW_TYPE: Record<string, string> = {
  monday: 'DOW_MONDAY',
  tuesday: 'DOW_TUESDAY',
  wednesday: 'DOW_WEDNESDAY',
  thursday: 'DOW_THURSDAY',
  friday: 'DOW_FRIDAY',
  saturday: 'DOW_SATURDAY',
  sunday: 'DOW_SUNDAY',
};

// Reverse mapping from DOW cap type to day name
export const DOW_TYPE_TO_DAY: Record<string, string> = {
  DOW_MONDAY: 'monday',
  DOW_TUESDAY: 'tuesday',
  DOW_WEDNESDAY: 'wednesday',
  DOW_THURSDAY: 'thursday',
  DOW_FRIDAY: 'friday',
  DOW_SATURDAY: 'saturday',
  DOW_SUNDAY: 'sunday',
};

export const qualityScoreDayFilterOptions: Option[] = [
  { label: 'Weekend', value: 'weekend' },
  { label: 'Weekdays', value: 'weekdays' },
  { label: 'Monday', value: 'monday' },
  { label: 'Tuesday', value: 'tuesday' },
  { label: 'Wednesday', value: 'wednesday' },
  { label: 'Thursday', value: 'thursday' },
  { label: 'Friday', value: 'friday' },
  { label: 'Saturday', value: 'saturday' },
  { label: 'Sunday', value: 'sunday' },
];

// AND/OR logic for the repeatable criteria lists (previous registrations, internal pre-pings).
export const AND_OR_OPTIONS: Option[] = [
  { label: 'All entries must pass', value: 'AND' },
  { label: 'Any of the entries must pass', value: 'OR' },
];

// Aff SubID adds a third mode: each entry only judges its own affiliate's traffic.
export const AFF_SUB_LOGIC_OPTIONS: Option[] = [
  ...AND_OR_OPTIONS,
  { label: 'Each entry evaluated independently', value: 'ANY' },
];
